import { render } from "./ServiceListingPage.vue?vue&type=template&id=935fbe7c"
import script from "./ServiceListingPage.vue?vue&type=script&lang=js"
export * from "./ServiceListingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__